module.exports = __webpack_public_path__ + "static/media/brl_note_100.2d1b09fc.jpg";